// 在 main.js 最顶部添加
window.WebSocket = function (...args) {
    // 打印连接信息，帮助定位来源
    console.log('有人尝试创建WebSocket连接:', args[0]);
    // 阻止连接建立
    return {
        close: () => { }, // 空实现避免报错
        send: () => { }
    };
};
// 开发模式下全局屏蔽 ResizeObserver 的已知循环通知警告，避免 dev overlay 报错
(function () {
    const isDev = (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development')
        || (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.DEV);
    if (!isDev) return;

    const handleROError = (e) => {
        try {
            if (e && e.message && e.message.indexOf('ResizeObserver loop completed with undelivered notifications') !== -1) {
                e.stopImmediatePropagation();
                e.preventDefault();
            }
        } catch (err) {
            // noop
        }
    };

    window.addEventListener('error', handleROError, true);
    // 屏蔽未捕获的 promise rejection 中由 ElementPlus 返回的 'cancel'（确认框取消）
    const handleUnhandledRejection = (e) => {
        try {
            const reason = e && e.reason;
            if (reason === 'cancel' || (reason && reason.toString && reason.toString().indexOf('cancel') !== -1)) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        } catch (err) {
            // noop
        }
    };
    window.addEventListener('unhandledrejection', handleUnhandledRejection, true);
})();
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import { createApp } from 'vue';
import App from './App.vue';
// 导入路由配置（需自行创建路由文件）
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'; // 引入中文语言包
import router from "./router";
import '@/assets/styles/theme.css';
// 2. Vue 3.x 项目全局注册（使用createApp）
const app = createApp(App)


// 注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(ElementPlus, {
    locale: zhCn, // 配置中文语言
})
app.use(router)
app.mount('#app')